import { Injectable } from '@angular/core';
import * as firebase from 'firebase'
import {AuthService} from './auth.service'
import {DateService} from "./date.service";

@Injectable({
  providedIn: 'root'
})
export class GraphService {

user = firebase.auth().currentUser.uid;
ref = firebase.database().ref('PageConfig/Home/Charts')
actifs
inactifs
divCible 
date_end
date_start
posX:number
posY:number
audioUrl:string = 'https://cdn.tones6.com/uploads/f1000/sonic_ring.mp3'
shopId
  constructor(private authService : AuthService,
              private dateService : DateService ) {}

  async saveGraphs(actifs, inactifs, page){
    if(page=='Home'){
      this.ref = firebase.database().ref('PageConfig/Home/Charts')
      this.ref.update({
        actifs : actifs,
        inactifs : inactifs
      });
    }
    if(page =="Service"){
      this.authService.getService().then(()=>{
        this.ref = firebase.database().ref('PageConfig/Service/'+localStorage.getItem('admin_service')+'/Charts')
      }).then(()=>{
        this.ref.update({
          actifs : actifs,
          inactifs : inactifs
        });
      })
    }
    if(page =="Profil"){
      this.authService.getService().then(()=>{
        this.ref = firebase.database().ref('PageConfig/Profil/'+this.user+'/Charts')
      }).then(()=>{
        this.ref.update({
          actifs : actifs,
          inactifs : inactifs
        });
      })
    }
    this.myFunction()
  }

  
  tt = 0
  myFunction () {
    this.dateService.changeMyVar(' '+this.tt++); // update variable
  }

  async setInactive(balise:string, page){
    if(page=='Home'){
      this.ref = firebase.database().ref('PageConfig/Home/Charts')
      this.ref.once("value", (snapshot) => {
        this.actifs = snapshot.val().actifs.split("_")
        this.inactifs = snapshot.val().inactifs.split("_")
      }).then(()=>{
        if(this.actifs){
          this.actifs = this.actifs.filter(word => word.length > 1 && word !== balise)
          let toSave = ""
          let toSaveInac = ""
          this.actifs.forEach(element => {
            toSave += element+'_'
          })
          this.inactifs.push(balise+'_')
          this.inactifs.forEach(element => {
            toSaveInac += element+'_'
          });
          this.saveGraphs(toSave, toSaveInac, page)
        }
      })
    }
    if(page =="Service"){
      this.authService.getService().then(()=>{
        this.ref = firebase.database().ref('PageConfig/Service/'+localStorage.getItem('admin_service')+'/Charts')
      }).then(()=>{
        this.ref.once("value", (snapshot) => {
          this.actifs = snapshot.val().actifs.split("_")
          this.inactifs = snapshot.val().inactifs.split("_")
        }).then(()=>{
          if(this.actifs){
            this.actifs = this.actifs.filter(word => word.length > 1 && word !== balise)
            let toSave = ""
            let toSaveInac = ""
            this.actifs.forEach(element => {
              toSave += element+'_'
            })
            this.inactifs.push(balise+'_')
            this.inactifs.forEach(element => {
              toSaveInac += element+'_'
            });
            this.saveGraphs(toSave, toSaveInac, page)
          }
        })

      })
    }
    if(page=="Profil"){
      
      this.ref = firebase.database().ref('PageConfig/Profil/'+this.user+'/Charts')
      this.ref.once("value", (snapshot) => {
        this.actifs = snapshot.val().actifs.split("_")
        this.inactifs = snapshot.val().inactifs.split("_")
      }).then(()=>{
        if(this.actifs){
          this.actifs = this.actifs.filter(word => word.length > 1 && word !== balise)
          let toSave = ""
          let toSaveInac = ""
          this.actifs.forEach(element => {
            toSave += element+'_'
          })
          this.inactifs.push(balise+'_')
          this.inactifs.forEach(element => {
            toSaveInac += element+'_'
          });
          this.saveGraphs(toSave, toSaveInac, page)
        }
      })
    }
  }

 

  changeType(chart:string, type:string){
    firebase.database().ref('PageConfig/Home/Charts/'+chart).update({
      type : type
    })
  }

  getPos(posX, posY){
    this.posX = posX;
    this.posY = posY;
  }

  setPosX(){
    return  this.posX;
  }
  setPosY(){
    return this.posY;
  }

  getAudioUrl(){
    return this.audioUrl;
  }
}
